// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Link } from 'gatsby';
import uuid from 'react-uuid';

// Components
import Image from '../../image/image';

// Hooks
import useMeetTheFounderOptions from '../../../hooks/useMeetTheFounderOptions';

// Styles
import TwoColumnLargeStyles from './twoColumnLarge.styles';

export default function TwoColumnLarge({
  layout,
  predefined,
  isFirstLayout,
  imageLoading,
}) {
  const meetTheFounderOptions = useMeetTheFounderOptions();

  const data = layout;

  if (predefined && predefined === 'meetTheFounder') {
    data.rows = [
      {
        column1: {
          heading: meetTheFounderOptions?.heading,
          text: meetTheFounderOptions?.text,
          buttons: meetTheFounderOptions?.buttons,
        },
        column2: {
          image: meetTheFounderOptions?.image,
        },
      },
    ];
  }

  const bgColor = data?.backgroundColour;
  const multiColumnText = data?.multiColumnText;
  const fullHeightImg = data?.fullHeightImage;
  const spaceBetweenRows = data?.spaceBetweenRows;
  const rows = data?.rows;

  return (
    <TwoColumnLargeStyles
      multiColumnText={multiColumnText}
      fullHeightImg={fullHeightImg}
      bgColor={bgColor}
      spaceBetweenRows={spaceBetweenRows}
    >
      {rows && (
        <>
          {rows.map(({ column1, column2 }) => (
            <div className="row" key={uuid()}>
              {!column1?.image && (
                <div className="column first text-column">
                  {column1?.heading && isFirstLayout ? (
                    <h1 className="heading large">
                      <span className="inner">{column1?.heading}</span>

                      {fullHeightImg && <span className="separator" />}
                    </h1>
                  ) : (
                    <h2 className="heading large">
                      <span className="inner">{column1?.heading}</span>

                      {fullHeightImg && <span className="separator" />}
                    </h2>
                  )}

                  {column1?.text && (
                    <div className="text-wrapper">{parse(column1?.text)}</div>
                  )}

                  {column1?.buttons && (
                    <div className="btn-group">
                      {column1?.buttons.map((button) => (
                        <Link
                          key={uuid()}
                          to={button?.button?.url}
                          className={`btn ${bgColor === 'white' && 'dark'}`}
                        >
                          {button?.button?.title}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {!column2?.image && (
                <div className="column second text-column">
                  {column2?.heading && isFirstLayout ? (
                    <h1 className="heading large">
                      <span className="inner">{column2?.heading}</span>

                      {fullHeightImg && <span className="separator" />}
                    </h1>
                  ) : (
                    <h2 className="heading large">
                      <span className="inner">{column2?.heading}</span>

                      {fullHeightImg && <span className="separator" />}
                    </h2>
                  )}

                  {column2?.text && (
                    <div className="text-wrapper">{parse(column2?.text)}</div>
                  )}

                  {column2?.buttons && (
                    <div className="btn-group">
                      {column2?.buttons.map((button) => (
                        <Link
                          key={uuid()}
                          to={button?.button?.url}
                          className={`btn ${bgColor === 'white' && 'dark'}`}
                        >
                          {button?.button?.title}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {column1?.image && (
                <div className="column first img-column">
                  <Image
                    image={column1?.image}
                    className={`img ${fullHeightImg ? 'full-height-img' : ''}`}
                    flex
                    alignItems="center"
                    loading={imageLoading}
                  />
                </div>
              )}

              {column2?.image && (
                <div className="column second img-column">
                  <Image
                    image={column2?.image}
                    className={`img ${fullHeightImg ? 'full-height-img' : ''}`}
                    flex
                    alignItems="center"
                    loading={imageLoading}
                  />
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </TwoColumnLargeStyles>
  );
}

TwoColumnLarge.propTypes = {
  layout: PropTypes.shape({
    backgroundColour: PropTypes.string,
    spaceBelow: PropTypes.bool,
    heading: PropTypes.string,
    text: PropTypes.string,
    multiColumnText: PropTypes.bool,
    button: PropTypes.shape({}),
    image: PropTypes.shape({
      altText: PropTypes.string,
      gatsbyImage: PropTypes.shape({}),
    }),
    fullHeightImage: PropTypes.bool,
    spaceBetweenRows: PropTypes.bool,
    column1: PropTypes.shape({
      heading: PropTypes.string,
    }),
    column2: PropTypes.shape({}),
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        column1: PropTypes.shape({
          heading: PropTypes.string,
          text: PropTypes.string,
          buttons: PropTypes.arrayOf(PropTypes.shape({})),
          backgroundImage: PropTypes.shape({
            altText: PropTypes.string,
            gatsbyImage: PropTypes.shape({}),
          }),
        }),
        column2: PropTypes.shape({
          heading: PropTypes.string,
          text: PropTypes.string,
          buttons: PropTypes.arrayOf(PropTypes.shape({})),
          backgroundImage: PropTypes.shape({
            altText: PropTypes.string,
            gatsbyImage: PropTypes.shape({}),
          }),
        }),
      }),
    ),
  }),
  predefined: PropTypes.string,
  isFirstLayout: PropTypes.bool,
  imageLoading: PropTypes.string.isRequired,
};

TwoColumnLarge.defaultProps = {
  layout: {},
  predefined: null,
  isFirstLayout: false,
};
